import { render } from "./Association.vue?vue&type=template&id=c0f965bc&scoped=true"
import script from "./Association.vue?vue&type=script&lang=js"
export * from "./Association.vue?vue&type=script&lang=js"

import "./Association.vue?vue&type=style&index=0&id=c0f965bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f965bc"]])

export default __exports__